'use client';

import { ActionButton } from '@/components/ui/ActionButton';
import { Typography } from '@/components/ui/Text';
import React, { ReactNode } from 'react';
import { IntakePageTextBox } from '../IntakePageTextBox';

import './IntakeStepWrapper.scss';

type Props = {
  heading: string;
  description?: string;
  children?: ReactNode;
  onSubmit: (e: React.FormEvent) => void;
  onBack?: () => void;
  showBack?: boolean;
  submitLabel?: string;
  isSubmitting?: boolean;
  submitDisabled?: boolean;
  footer?: React.ReactNode;
};

export const IntakeStepWrapper = ({
  heading,
  description,
  children,
  onSubmit,
  onBack,
  showBack = false,
  submitLabel = 'Continue',
  isSubmitting = false,
  submitDisabled = false,
  footer,
}: Props) => (
  <div className='IntakeStepWrapper mx-auto w-full max-w-[800px] px-4 py-8'>
    <form
      onSubmit={onSubmit}
      className='IntakeStepWrapper__form flex flex-col gap-[40px]'
    >
      <div className='flex flex-col items-center gap-[24px] text-center xl:gap-[40px]'>
        <h1
          className={`font-serif text-[27px] leading-[115%] font-light xl:text-[36px] xl:leading-[130%]`}
        >
          {heading}
        </h1>

        {description && (
          <IntakePageTextBox>
            <Typography variant='body'>{description}</Typography>
          </IntakePageTextBox>
        )}
      </div>

      {children}

      <div className='flex flex-col gap-[16px] max-md:hidden md:flex-row md:gap-[48px]'>
        {showBack && (
          <ActionButton
            label='Back'
            variant='secondary'
            type='button'
            onClick={onBack}
            className='hidden flex-1 md:order-1 md:block'
          />
        )}

        <ActionButton
          label={isSubmitting ? 'Loading...' : submitLabel}
          variant='primary'
          type='submit'
          disabled={isSubmitting || submitDisabled}
          className='w-full flex-1 max-md:hidden md:order-2 md:w-auto'
        />
      </div>

      <div className='IntakeStepWrapper__button-wrapper md:hidden'>
        <ActionButton
          label={isSubmitting ? 'Loading...' : submitLabel}
          variant='primary'
          type='submit'
          disabled={isSubmitting || submitDisabled}
          className='IntakeStepWrapper__button'
        />
      </div>

      {footer}
    </form>
  </div>
);
